import { render, staticRenderFns } from "./tvChart.vue?vue&type=template&id=294c4dc3"
import script from "./tvChart.vue?vue&type=script&lang=js"
export * from "./tvChart.vue?vue&type=script&lang=js"
import style0 from "./tvChart.vue?vue&type=style&index=0&id=294c4dc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.106.2__lodash@4.18.1_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports